export const getURLFromFilterParams = (params) => {
  let result = '/'
  Object.entries(params).forEach(([field, value]) => {
    if (value !== '' && value !== undefined) {
      result = `${result}${field}=${value}&`
    }
  })
  if (result[result.length - 1] === '&' || result[result.length - 1] === '/') {
    return result.slice(0, -1)
  }
  return result
}

/** Сегмент `:params?` идентичен тому, что получился бы из `filter` при сборке URL. */
export const isSameParams = (params, filter = {}) => {
  const segment = params ?? ''
  const u = getURLFromFilterParams(filter)
  let fromFilter = ''
  if (u && u !== '/') {
    fromFilter = u.startsWith('/') ? u.slice(1) : u
  }
  return segment === fromFilter
}